<!--
 * @Date: 2022-10-24 16:01:06
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-06-13 16:47:59
 * @FilePath: /nicee-web-tw/src/upgrade-page/views/line-recharge/tappay.vue
 * @Description: tappay支付
-->
<template>
  <el-dialog
    width="90%"
    top="12vh"
    :visible.sync="show"
    center
    append-to-body
    :custom-class="customClass"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="container" v-loading="loading">
      <div class="header">
        <img class="tappay-logo" src="./images/tapPay.png" alt="" />
        <i class="el-icon-close close-icon" @click="closeDialog"></i>

        <i
          class="el-icon-arrow-left back-icon"
          @click="activePage = 1"
          v-if="cardList && cardList.length && activePage === 2"
        ></i>
      </div>
      <div class="info">
        <div>
          <span class="label">商品名稱：</span>
          <span>{{ rechargeName }}</span>
        </div>
        <div>
          <span class="label">訂單金額：</span>
          <span class="value">NT$ {{ price }}</span>
        </div>
      </div>
      <form class="paypal-form-box" ref="form" v-show="activePage === 2">
        <div class="form-group card-number-group">
          <label
            for="card-number"
            class="control-label control-label-card-number"
          >
            <span>信用卡/金融卡卡號</span>
            <div>
              <img class="card-logo" src="./images/visa.png" alt="" />
              <img class="card-logo" src="./images/mastercard.png" alt="" />
              <img class="card-logo" src="./images/jcb.png" alt="" />
            </div>
          </label>
          <div class="card-number-box">
            <img class="card-logo" src="./images/card.png" alt="" />
            <div class="form-control card-number"></div>
          </div>
        </div>
        <div class="time-code-group">
          <div class="form-group expiration-date-group">
            <label for="expiration-date" class="control-label">有效年月</label>
            <div
              class="form-control expiration-date"
              id="tappay-expiration-date"
            ></div>
          </div>
          <div class="form-group ccv-group">
            <label for="ccv" class="control-label">背面末三碼</label>
            <div class="form-control ccv" id="form-control-ccv"></div>
          </div>
        </div>
        <div class="remember-box">
          <el-checkbox
            v-model="submitObj.remember"
            shape="square"
          ></el-checkbox>
          <span class="message">我同意記住卡片資訊，以方便下次結帳。</span>
        </div>
        <button class="c-button" ref="submitButton" type="submit" disabled>
          前往付款
        </button>
      </form>
      <div class="card-list-box" v-show="activePage === 1">
        <div class="control-label">選擇信用卡/金融卡</div>
        <ul>
          <li
            class="card-list"
            v-for="item of cardList"
            :key="item.id"
            @click="selectCard(item.id)"
          >
            <img
              class="card-logo"
              src="./images/visa.png"
              alt=""
              v-if="item.type === 1"
            />
            <img
              class="card-logo"
              src="./images/mastercard.png"
              alt=""
              v-else-if="item.type === 2"
            />
            <img
              class="card-logo"
              src="./images/jcb.png"
              alt=""
              v-else-if="item.type === 3"
            />
            <img class="card-logo" src="./images/card.png" alt="" v-else />
            <span>****</span>
            <span>****</span>
            <span>****</span>
            <span>{{ item.lastCode }}</span>
          </li>
        </ul>
        <div class="control-label other">或者</div>
        <button class="c-button" type="button" @click="activePage = 2">
          使用其他信用卡/金融卡
        </button>
      </div>
      <br />
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'Tappay',
  props: {
    rechargeUuid: {
      type: String,
      default: ''
    },
    // 商品名稱
    rechargeName: {
      type: String,
      default: '心約餘額儲值'
    },
    // 商品价格
    price: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false, //是否顯示彈窗
      isInit: false, // 是否已經初始化sdk
      cardList: [], //银行卡列表
      activePage: 2, //默认显示信用卡表单输入界面
      loading: false,
      submitObj: {
        remember: false, // 是否記住卡片信息
        prime: '', //支付的prime
        cardId: null //银行卡id
      }
    };
  },
  watch: {},
  computed: {
    customClass() {
      return window.innerWidth >= 600 ? 'tappay pc' : 'tappay';
    }
  },
  mounted() {},
  created() {
    if (!window.TPDirect) {
      require('@/sdk/tappay-v5.13.js');
    }
  },
  methods: {
    // 初始化tappay
    init() {
      if (!this.isInit) {
        this.$nextTick(() => {
          this.$refs.form.addEventListener('submit', event => {
            event.preventDefault();
            // Get prime
            TPDirect.card.getPrime(result => {
              this.submitObj.prime = result.card.prime;
              this.submitObj.cardId = null;
              this.submit();
              console.log('result', result);
              if (result.status !== 0) {
                alert('get prime error ' + result.msg);
                return;
              }
            });
          });
          TPDirect.setupSDK(
            126179,
            'app_rk7WiBr8Llr4pe5Ewpt1Y2WGxGh3fqQc8JnR20TgHdajAqUOrztVvHuRLguk',
            process.env.VUE_APP_ENV === 'production' ? 'production' : 'sandbox'
          );
          TPDirect.card.setup({
            fields: {
              number: {
                element: '.form-control.card-number',
                placeholder: '**** **** **** ****'
              },
              expirationDate: {
                element: document.getElementById('tappay-expiration-date'),
                placeholder: 'MM / YY'
              },
              ccv: {
                element: document.getElementById('form-control-ccv'),
                placeholder: '後三碼'
              }
            },
            styles: {
              input: {
                color: 'gray'
              },
              'input.ccv': {
                // 'font-size': '16px'
              },
              ':focus': {
                color: 'black'
              },
              '.valid': {
                color: 'green'
              },
              '.invalid': {
                color: 'red'
              },
              '@media screen and (max-width: 400px)': {
                input: {
                  color: 'orange'
                }
              }
            },
            // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
            isMaskCreditCardNumber: true,
            maskCreditCardNumberRange: {
              beginIndex: 6,
              endIndex: 11
            }
          });
          // listen for TapPay Field
          TPDirect.card.onUpdate(update => {
            if (update.canGetPrime) {
              this.$refs.submitButton.removeAttribute('disabled');
            } else {
              this.$refs.submitButton.setAttribute('disabled', true);
            }

            // number 欄位是錯誤的
            if (update.status.number === 2) {
              this.setNumberFormGroupToError('card-number-group');
            } else if (update.status.number === 0) {
              this.setNumberFormGroupToSuccess('card-number-group');
            } else {
              this.setNumberFormGroupToNormal('card-number-group');
            }

            if (update.status.expiry === 2) {
              this.setNumberFormGroupToError('expiration-date-group');
            } else if (update.status.expiry === 0) {
              this.setNumberFormGroupToSuccess('expiration-date-group');
            } else {
              this.setNumberFormGroupToNormal('expiration-date-group');
            }

            if (update.status.ccv === 2) {
              this.setNumberFormGroupToError('ccv-group');
            } else if (update.status.ccv === 0) {
              this.setNumberFormGroupToSuccess('ccv-group');
            } else {
              this.setNumberFormGroupToNormal('ccv-group');
            }
          });
          this.isInit = true;
        });
      }
    },
    setNumberFormGroupToError(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.add('has-error');
      classList.remove('has-success');
    },
    setNumberFormGroupToSuccess(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.add('has-success');
      classList.remove('has-error');
    },
    setNumberFormGroupToNormal(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.remove('has-success');
      classList.remove('has-error');
    },
    // 获取银行卡列表
    async getCardList() {
      const params = this.rechargeUuid
        ? {
            userUuid: this.rechargeUuid
          }
        : null;
      try {
        const { data } = await this.$http.get(
          '/payment/tabPay/cardList',
          params
        );
        this.cardList = data || [];
        return true;
      } catch (error) {
        return false;
      }
    },
    // 打開彈窗
    async openDialog() {
      this.show = true;
      this.loading = true;
      this.submitObj = {
        remember: false,
        prime: '',
        cardId: null
      };
      this.init();
      await this.getCardList();
      if (this.cardList && this.cardList.length) {
        this.activePage = 1;
      }
      this.loading = false;
    },
    // 關閉彈窗
    closeDialog() {
      this.show = false;
    },
    // 提交
    submit() {
      this.$emit('submit', this.submitObj);
    },
    // 选择银行卡
    selectCard(id) {
      this.submitObj.cardId = id;
      this.submitObj.prime = 'cardToken-' + id;
      this.submit();
    }
  }
};
</script>
<style lang="scss">
.el-dialog.tappay {
  padding-top: 0;
  background: rgba(247, 247, 247, 1);
  border-radius: 22px;
  .container {
    .header {
      position: relative;
      text-align: center;
      margin-bottom: 19px;
      .tappay-logo {
        width: 100px;
      }
      .close-icon,
      .back-icon {
        position: absolute;
        top: 50%;
        color: rgb(155, 155, 155);
        font-size: 20px;
      }
      .close-icon {
        right: 0;
        transform: translateY(-52%);
      }
      .back-icon {
        left: 0;
        transform: translateY(-50%);
      }
    }
    .info {
      color: rgba(34, 44, 67, 1);
      font-size: 17px;
      font-weight: bold;
      margin: 20px 0;
      border-bottom: 2px solid rgba(34, 44, 67, 1);
      > div {
        margin-bottom: 18px;
      }
      .value {
        font-weight: 600;
        font-size: 17px;
        line-height: 24px;
      }
    }
  }
  .control-label {
    color: rgba(155, 155, 155, 1);
    font-size: 12px;
    margin-bottom: 8px;
    display: inline-block;
  }
  .form-group {
    margin-bottom: 19px;
  }
  .form-control {
    height: 50px;
  }
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }
  .card-number-group {
    .control-label-card-number {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-logo {
        margin-left: 4px;
      }
    }
    .card-number-box {
      display: flex;
      align-items: center;
      border-radius: 4px;
      border: 1px solid rgba(60, 60, 67, 0.2);
      background: rgba(255, 255, 255, 1);
      .card-logo {
        margin: 0 12px;
      }
    }
    .card-logo {
      width: 29px;
    }
  }
  .time-code-group {
    display: flex;
    .form-control {
      border-radius: 7.7px;
      border: 1px solid rgba(60, 60, 67, 0.2);
      background: rgba(255, 255, 255, 1);
      padding-left: 11px;
    }
    .expiration-date-group {
      margin-right: 10px;
    }
    .ccv-group {
      margin-left: 10px;
    }
  }
  .remember-box {
    display: flex;
    align-items: center;
    margin-top: 4px;
    .message {
      display: inline-block;
      margin-left: 5px;
      color: rgba(155, 155, 155, 1);
      font-size: 12px;
    }
  }
  .c-button {
    display: block;
    // width: calc(40vw);
    height: 40px;
    color: #222c43;
    background: #fed838;
    border-radius: 96px;
    margin: auto;
    margin-top: 42px;
    cursor: pointer;
    width: 100%;
    &:disabled {
      background: rgba(60, 60, 67, 0.2) !important;
      color: rgba(99, 103, 134, 0.3) !important;
    }
  }
  .card-list-box {
    > ul {
      max-height: 252px;
      overflow: auto;
      margin-bottom: 30px;
    }
    .control-label {
      font-size: 14px;
    }
    .c-button {
      background: rgba(247, 247, 247, 1);
      border: 1px solid rgba(60, 60, 67, 0.2);
    }
    .card-list {
      height: 52px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      border: 1px solid rgba(60, 60, 67, 0.2);
      color: rgba(82, 82, 82, 1);
      font-size: 20px;
      margin-bottom: 15px;
      cursor: pointer;
      span {
        margin-right: 5px;
      }
      &:hover {
        background-color: #e9e9e9;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .card-logo {
      width: 29px;
      margin: 0 12px;
    }
    .other {
      display: block;
      text-align: center;
    }
    .c-button {
      margin-top: 15px;
      height: 46px;
      line-height: 46px;
    }
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px;
  }
}
.el-dialog.tappay.pc {
  max-width: 300px;
}
</style>
